import React, {Component} from 'react';
import PrintPreview from './PrintPreview'
import WorkdocStore from '../../stores/WorkdocStore'
import './fixing/Print.css'

const DEFAULT_ROW = 31
class PrintReportWorkDocPurchaseOrder extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {
        loading:false,
        dataList:[],
        data:{dataList:[],itemTypes:[],status:[]},
        summary:{po_amount_before_discount:0,po_discount:0,po_amount:0},
        report_title:'กำลังดึงข้อมูล..'
      }

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        WorkdocStore.loadWorkdocPurchaseOrder(this.props.workNo, (result) => {
            let data = {dataList:[],itemTypes:[],status:[]}
            let summary = {po_amount_before_discount:0,po_discount:0,po_amount:0}
            data.dataList = result.data.map((item,index)=>{
              const po_amount_before_discount = (item.po_amount*1+item.po_discount*1)
              summary.po_amount_before_discount += po_amount_before_discount
              summary.po_discount += item.po_discount*1
              summary.po_amount += item.po_amount*1
              return(
                {
                  id:item.bf_work_damage_id,
                  itemName:item.detail,
                  quantity:item.quantity,
                  itemTypeId:item.part_type,
                  shopName:item.shop_name,
                  shopId:item.shop_id,
                  purchaseOrder:item.purchase_order_no,
                  issueDate:item.po_date,
                  statusId:item.po_status,
                  remark:item.remark,
                  po_received_date:item.po_received_date,
                  po_amount_before_discount:po_amount_before_discount,
                  po_discount:item.po_discount,
                  po_amount:item.po_amount,
                  exportwork_date:item.exportwork_date,
                  payment_date:item.payment_date,
                  amount:item.amount,
                  part_by:item.part_by
                }
              )
            })
            data.itemTypes = result.itemTypes
            data.status  = result.status
            this.setState({report_title:'ไม่พบข้อมูล',loading:false,data:data,dataList:this.getPagination(data.dataList),summary:summary,status:result.status,itemTypes:result.itemTypes})
        })
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary() {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total = total + (item.amount==''||item.amount==null||item.amount==undefined||isNaN(item.amount)?0:parseFloat(item.amount))
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderStatus(statusId) {
        if (statusId === '1') {
          return 'อนุมัติแล้ว'
        } else if (statusId === '2') {
          return 'ได้รับของแล้ว'
        } else if (statusId==='3') {
          return 'นำเข้าสต็อกเรียบร้อย'
        } else if (statusId==='4') {
          return 'นำไปซ่อมแล้ว'
        } else {
          return ''
        }
    }

    renderRowData(data,indexs) {
        let {itemTypes} = this.state
        if (data.length==0) {
          return(<tr><td colSpan={16}>ไม่พบข้อมูล</td></tr>)
        } else {
            return(
                data.map((item, index) => { 
                    let _itemTypes = itemTypes.find((_item,_index)=>{
                        return item.itemTypeId==_item.itemTypeId
                    })
                    let disabled = (item.id*1==-1)
                    return(
                        <tr key={index} className={disabled?'bg-yellow':''}>
                            <td style={{verticalAlign:'middle'}} className='text-center'>{((DEFAULT_ROW-1)*indexs)+(index+1)}</td>
                            <td style={{verticalAlign:'middle'}}>
                                {item.itemName}
                            </td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>
                                {item.quantity}
                            </td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>
                                {_itemTypes!=undefined?_itemTypes.title:''}               
                            </td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>
                                {item.part_by=='garage'?'อู่':item.part_by='branch'?'สาขา':item.part_by=='insurance'?'ประกัน':item.part_by=='customer'?'ลูกค้า':''}               
                            </td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>
                                <div style={{width:'60px',whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis'}}>{item.shopName}</div>
                            </td>
                            <td style={{verticalAlign:'middle'}} className='text-right'>{this.getNumberFormat(item.po_amount_before_discount)}</td>
                            <td style={{verticalAlign:'middle'}} className='text-right'>{this.getNumberFormat(item.po_discount)}</td>
                            <td style={{verticalAlign:'middle'}} className='text-right'>{this.getNumberFormat(item.po_amount)}</td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>{item.purchaseOrder}</td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>{item.issueDate}</td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>{item.po_received_date}</td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>{item.exportwork_date}</td>
                            <td style={{verticalAlign:'middle'}} className='text-right'>{item.payment_date}</td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>{this.renderStatus(item.statusId)}</td>
                            <td style={{verticalAlign:'middle'}} className='text-center'>
                                {item.remark}
                            </td>
                        </tr>
                    )
                })        
            )
        }
    }

    renderTable(item,index,length) {
        let {type} = this.props
        let {summary} = this.state
        return(
            <table className='table table-print-report-fixing table-font-print-sm'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{width:'50px'}}>ลำดับ</td>
                        <td className='text-center' style={{width:'450px'}}>รายการอะไหล่</td>
                        <td className='text-center' style={{width:'80px'}}>จำนวน</td>
                        <td className='text-center' style={{width:'80px'}}>ประเภท</td>
                        <td className='text-center' style={{width:'80px'}}>ผู้จัดอะไหล่</td>
                        <td className='text-center' style={{width:'60px'}}>ร้านที่สั่ง</td>
                        <td className='text-center' style={{width:'100px'}}>ราคา<br/>ก่อนส่วนลด</td>
                        <td className='text-center' style={{width:'100px'}}>ส่วนลด</td>              
                        <td className='text-center' style={{width:'100px'}}>ราคาสินค้า</td>
                        <td className='text-center' style={{width:'140px'}}>ใบสั่งซื้อ</td>
                        <td className='text-center' style={{width:'110px'}}>วันออกเอกสาร</td>
                        <td className='text-center' style={{width:'110px'}}>วันรับ<br/>อะไหล่เข้า</td>
                        <td className='text-center' style={{width:'110px'}}>วันเบิกซ่อม</td>
                        <td className='text-center' style={{width:'110px'}}>ชำระเงินแล้ว</td>
                        <td className='text-center' style={{width:'150px'}}>สถานะสั่งซื้อ</td>
                        <td className='text-center' style={{width:'300px'}}>หมายเหตุ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {index==length-1?
                    <tr>
                        <td colSpan={6} className='text-right'>
                            รวมเป็นเงิน
                        </td>
                        <td className='text-right'>{this.getNumberFormat(summary.po_amount_before_discount)}</td>    
                        <td className='text-right'>{this.getNumberFormat(summary.po_discount)}</td>    
                        <td className='text-right'>{this.getNumberFormat(summary.po_amount)}</td>
                        <td className='text-right'></td> 
                        <td className='text-right'></td> 
                        <td className='text-right'></td> 
                        <td className='text-right'></td> 
                        <td className='text-right'></td> 
                        <td className='text-right'></td> 
                        <td className='text-right'></td>                         
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportWorkDocPurchaseOrder.defaultProps = {
    title: 'ตารางรายงานใบสั่งซื้อ',
    mode: '',
    workNo: ''
  }
  export default PrintReportWorkDocPurchaseOrder;


// WEBPACK FOOTER //
// ./src/view/print/PrintReportWorkDocPurchaseOrder.js